import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const BookingCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="status-page">
      <div className="status-content">
        <div className="status-icon" style={{ color: '#ef4444' }}>
          <XCircle size={80} />
        </div>
        <h1 className="status-title" data-testid="cancel-title">Booking Cancelled</h1>
        <p className="status-message">
          Your booking has been cancelled. No charges have been made.
        </p>
        <button 
          className="cta-button" 
          onClick={() => navigate('/')}
          data-testid="home-button"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default BookingCancelPage;